// work data

export const Work = [
  {
    id: 1,
    name: "AirCast - Next-Day Air Quality Forecasting",
    description:
      "End-to-end ML pipeline that forecasts next-day AQI value and category for 141 Indian cities. Deployed on Streamlit.",
    tags: ["python", "scikit-learn", "xgboost", "streamlit"],

    demo: "https://aircast-manglam.streamlit.app",
    github: "https://github.com/Manglam11/air_cast",
  },
  {
    id: 2,
    name: "Spectra - AI-Powered EDA Platform",
    description:
      "Upload any CSV for instant statistical profiling, interactive charts, and natural-language Q&A powered by a Groq LLM.",
    tags: ["python", "streamlit", "mysql", "llm"],

    demo: "https://spectra-v01.streamlit.app/",
    github: "https://github.com/Manglam11/spectra",
  },
  {
    id: 3,
    name: "Taska - Smart Task Management System",
    description:
      "Full-stack Flask + PostgreSQL task manager with auth, real-time WebSocket updates, and a Pandas analytics dashboard.",
    tags: ["python", "flask", "postgresql", "websockets"],

    demo: "https://taska-2noj.onrender.com",
    github: "https://github.com/Manglam11/Taska",
  },
  {
    id: 4,
    name: "Binance Futures Testnet Trading Bot",
    description:
      "Production-grade CLI for MARKET, LIMIT, and STOP-LIMIT orders on the Binance Futures Testnet via signed REST calls.",
    tags: ["python", "rest-api", "typer", "automation"],

    demo: "",
    github: "https://github.com/Manglam11/binance-futures-testnet-bot",
  },
  {
    id: 5,
    name: "Lead Generation Automation",
    description:
      "Automated pipeline that pulls developer leads from the GitHub API, cleans them with Pandas, and exports to Excel.",
    tags: ["python", "pandas", "github-api", "automation"],

    demo: "",
    github: "https://github.com/Manglam11/lead_gen_automation",
  },
  {
    id: 6,
    name: "Deal Finder - Amazon Price Tracker",
    description:
      "Scrapes live Amazon prices and emails an alert when a product drops below your target. Runs daily via GitHub Actions.",
    tags: ["python", "beautifulsoup", "web-scraping", "automation"],

    demo: "",
    github: "https://github.com/Manglam11/deal_finder",
  },
  {
    id: 7,
    name: "Stock News Alert System",
    description:
      "Monitors stock moves via the Alpha Vantage API and sends WhatsApp alerts with relevant news on large price swings.",
    tags: ["python", "rest-api", "whatsapp-api", "automation"],

    demo: "",
    github: "https://github.com/Manglam11/trading_news_alert",
  },
];
